import { render, staticRenderFns } from "./ServiceHelp.vue?vue&type=template&id=77b523ce&"
import script from "./ServiceHelp.vue?vue&type=script&lang=js&"
export * from "./ServiceHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77b523ce')) {
      api.createRecord('77b523ce', component.options)
    } else {
      api.reload('77b523ce', component.options)
    }
    module.hot.accept("./ServiceHelp.vue?vue&type=template&id=77b523ce&", function () {
      api.rerender('77b523ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FWueGFO6DSPu/JS/comp/ServiceHelp.vue"
export default component.exports